/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Sarthak's Portfolio",
  description:
    "Unleashing the Power of AI, Blockchain, and Other Transformative Technologies: Fueling Innovation for a Brighter Future and Empowering All",
  og: {
    title: "Sarthak Shastri's Portfolio",
    type: "website",
    url: "http://sarthakshastri.com/",
  },
};

//Home Page
const greeting = {
  title: "Sarthak Shastri",
  logo_name: "Sarthak Shastri",
  subTitle:
    "Unleashing the Power of AI, Blockchain, and Other Transformative Technologies: Fueling Innovation for a Brighter Future and Empowering All",
  resumeLink: "https://drive.google.com/file/d/1jylFrSz9mHqW_X8_1CYd_EN6dKq0CoX8/view?usp=sharing",
  portfolio_repository: "",
  githubProfile: "https://github.com/sarthak815",
};

const socialMediaLinks = [

  {
    name: "Github",
    link: "https://github.com/sarthak815",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sarthak-s-676285186/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:sarthak.shastri@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/sarthakshastri",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Research Gate",
    link: "https://www.researchgate.net/profile/Sarthak-Shastri",
    fontAwesomeIcon: "fa-researchgate", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#808080", // Reference https://simpleicons.org/?q=twitter
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Worked as a Research Assistant at Manipal Institute of Technology",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Winner at Treehacks By Stanford 2024 built groupgrub a group restaurant recommendation system",
        "⚡ Winner of Bajaj Finserv HackRX2.0, Github Innovation Series and runners up at IEEE BigMM Data Challenge",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "Scikit-learn",
          fontAwesomeClassname: "simple-icons:scikitlearn",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Blockchain Protocol Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Experience working on MOI protocol(moi.technology, an L1 blockchain protocol",
        "⚡ Built key functionality for the computational engine of MOI protocol",
        "⚡ Ran gas cost benchamrking and implementation for protocol",
      ],
      softwareSkills: [
        {
          skillName: "Protocol Development",
          fontAwesomeClassname: "eos-icons:blockchain",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Golang",
          fontAwesomeClassname: "skill-icons:golang",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Ethereum",
          fontAwesomeClassname: "logos:ethereum",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JSON-RPC",
          fontAwesomeClassname: "tabler:json",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Rust",
          fontAwesomeClassname: "skill-icons:rust",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "logos:postman-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Bitcoin",
          fontAwesomeClassname: "logos:bitcoin",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Yaml",
          fontAwesomeClassname: "simple-icons:yaml",
          style: {
            color: "#CB3837",
          },
        },
      ],
    },
    {
      title: "Systems and Programming Language Development ",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on development of Cocolang, a resource oriented language",
        "⚡ Worked on development of PISA, the VM used to execute contracts on the MOI protocol",
        "⚡ Added key functionality to AST -> Bytecode phase",
      ],
      softwareSkills: [
        {
          skillName: "Rust",
          fontAwesomeClassname: "skill-icons:rust",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Golang",
          fontAwesomeClassname: "skill-icons:golang",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Mobile Application Development",
      fileName: "DesignImg",
      skills: [
        "⚡ Began my development journey with Android apps using Java",
        "⚡ Finalist of Treehacks by Stanford 2021",
        "⚡ Took up CSE4083 IOS Application Development in 7th Semester",
      ],
      softwareSkills: [
        {
          skillName: "Android",
          fontAwesomeClassname: "logos:android-vertical",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Android Studio",
          fontAwesomeClassname: "devicon:androidstudio",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "vscode-icons:file-type-firebase",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "IOS",
          fontAwesomeClassname: "simple-icons:ios",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "XCode",
          fontAwesomeClassname: "devicon:xcode",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/sarthaks1/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/sarthak_shastri",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/sarthak815",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://codeforces.com/profile/leprofessor11",
    },
    {
      siteName: "Devpost",
      iconifyClassname: "simple-icons:devpost",
      style: {
        color: "#323754",
      },
      profileLink: "https://devpost.com/sarthak-shastri",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/sarthakshastri",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Northeastern University",
      subtitle: "MS in Computer Science",
      logo_path: "neu_logo.png",
      alt_name: "NEU",
      duration: "Sep 2023 - May 2025",
      descriptions: [
        "⚡ GPA: 4/4 (highest score in the program)",
        "⚡ Was associated with research during my Bachelors which inspired me to pursue a masters degree",
        "⚡ Looking to dive deeper into courses related to Computer Systems and Artificial Intelligence",
      ],
      website_link: "https://www.northeastern.edu/",
    },

    {
      title: "Manipal Institute of Technology",
      subtitle: "B.Tech. in Information Technology, Minor in Big Data",
      logo_path: "manipal_logo.png",
      alt_name: "MIT Manipal",
      duration: "July 2019 - August 2023",
      descriptions: [
        "⚡ GPA: 3.73/4 (top 10 percent of my class)",
        "⚡ I studied courses such as DS, OOP, OS, Embedded Systems, CyberSecurity, Deep Learning and Big Data",
        "⚡ I served as the General Secretary of International Organisation of Software Developers(IOSD) - Manipal Chapter",
        "⚡ I worked as an organizer for Tech Tatva, the annual national level technical event",
      ],
      website_link: "http://manipal.edu",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Python for Everybody",
      subtitle: "- Charles Russell Severance",
      logo_path: "umich_logo.png",
      certificate_link:
        "https://coursera.org/share/7a5b7462cdad2639371c9957eb512990",
      alt_name: "University of Michigan",
      color_code: "#8C151599",
    },
    {
      title: "Convolutional Neural Networks",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/G4VTFPQC556N",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Graph Analytics for Big Data",
      subtitle: "- Amarnath Gupta",
      logo_path: "ucsd_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/E56W62624P39",
      alt_name: "UCSD",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Analysis with Python",
      subtitle: "- Joseph Santarcangelo",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/7A8P9VDSUHDP",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Graph Analytics for Big Data",
      subtitle: "- Amarnath Gupta",
      logo_path: "ucsd_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/8DANMERWEWFA",
      alt_name: "UCSD",
      color_code: "#0C9D5899",
    },
    {
      title: "Machine Learning with Python",
      subtitle: "- Saeed Aghabozorgi",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/SNE9YAKRSDD3",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Android App Development",
      subtitle: "- MyCaptain",
      logo_path: "mycap_logo.png",
      certificate_link:
        "https://github.com/sarthak815/MyCAP_AI/blob/master/MyCaptain%20Android%20App%20Development%20workshop%20certificate%20(2).pdf",
      alt_name: "Google",
      color_code: "#00000000",
    },
    {
      title: "Neural Networks and Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://coursera.org/share/45c643545dd83711741fac419a2dcf24",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Big Data Modeling and Management Systems",
      subtitle: "- Amarnath Gupta",
      logo_path: "ucsd_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/7LUAJPFAE3RD",
      alt_name: "UCSD",
      color_code: "#0C9D5899",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Co-op, Internship and Volunteership",
  description:
    "I have worked as blockchain protocol developer in a start-up pioneering in the personalized blockchain space. I have also worked as a Research Assistant at the Manipal Institute of Technology during my bachelors.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Co-op",
      experiences: [
        {
          title: "Graduate Software Engineer Co-op",
          company: "Sarva Labs Inc.",
          company_url: "https://sarva.ai",
          logo_path: "sarva_logo.png",
          duration: "May 2024 - Dec 2024",
          location: "Boston, MA",
          description:
            "Worked to build compiler for Coco(smart contract programming language) in Rust. Built and maintained VScode language extension for Coco.",
          color: "#0879bf",
        },
        {
          title: "Software Engineer Co-op",
          company: "Sarva Labs Inc.",
          company_url: "https://sarva.ai",
          logo_path: "sarva_logo.png",
          duration: "Jan 2023 - Aug 2023",
          location: "Bangalore, India",
          description:
            "I am working on the development of the compute engine of the MOI blockchain protocol being developed at Sarva Labs. My work is primarily focused on development related to the compiler and the virtual machine.",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Summer Intern",
          company: "Sarva Labs Inc.",
          company_url: "https://sarva.ai",
          logo_path: "sarva_logo.png",
          duration: "June 2022 - Oct 2022",
          location: "Bangalore, India",
          description:
            "I received a month long training on blockchain protocol development on programming in GO, encoding schemes, api development, consensus algorithms and networking stack implementation. I also worked on implementing sparse merkle trees into the protocol. Based on my performance, I received a returning co-op + full-time offer. ",
          color: "#0879bf",
        },
        {
          title: "Undergraduate Research Assistant",
          company: "Manipal Institute of Technology",
          company_url: "https://www.manipal.edu/",
          logo_path: "manipal_logo.png",
          duration: "Aug 2021 - May 2023",
          location: "Manipal, India",
          description:
            "I contributed to medical science projects by developing the AI component, focusing on computer vision and machine learning models. My work involved leveraging advanced technologies to enhance healthcare. Through computer vision, I analyzed medical images, aiding in the detection and diagnosis of conditions. In machine learning, I process vast amounts of medical data, generating valuable insights for personalized treatment and drug discovery. My efforts were to bridge the gap between AI and medicine, revolutionizing patient care and accelerating research. ",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Social Services Volunteer",
          company: "youth for Volunteering by AIESEC",
          company_url: "https://aiesec.org/",
          logo_path: "aiesec_logo.png",
          duration: "Dec 2019 - April 2021",
          location: "Manipal, India",
          description:
            "I enthusiastically dedicated my free time to serving at diverse locations, notably the ASARE rehabilitation center, where I engaged in conducting engaging activities and fostering meaningful connections with the residents living with Down syndrome. Additionally, I actively contributed to the betterment of our community by participating in tree plantation initiatives and beach cleaning drives throughout the scenic town of Manipal.",
          color: "#4285F4",
        },
        {
          title: "General Secretary",
          company: "International Organisation of Software Developers(IOSD) Manipal",
          company_url: "https://www.iosd.tech/",
          logo_path: "iosd_logo.png",
          duration: "May 2021 - June 2022",
          location: "Manipal, India",
          description:
            "I acted as the dedicated intermediary between the university administration and the club. During this period, I also assumed the responsibility of mentoring over 50 students, assisting them in acquiring the necessary skills for securing software engineering internships. Throughout my tenure, I conducted weekly sessions on Data Structures and Algorithms, recognizing their significance in software engineering interviews. By facilitating seamless communication and fostering individual growth, I aimed to contribute selflessly to the success of both the club and the students, enabling them to thrive in their aspirations for software engineering positions.",
          color: "#D83B01",
        },

      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. I enjoy building end-to-end applications for hackathons.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications, with more in the pipeline",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
      name: "Role of Deep Learning in Prostate Cancer Management: Past, Present and Future Based on a Comprehensive Literature Review",
      createdAt: "June 2022",
      description: "This review aims to present the applications of deep learning (DL) in prostate cancer diagnosis and treatment. Computer vision is becoming an increasingly large part of our daily lives due to advancements in technology. These advancements in computational power have allowed more extensive and more complex DL models to be trained on large datasets. Urologists have found these technologies help them in their work, and many such models have been developed to aid in the identification, treatment and surgical practices in prostate cancer. This review will present a systematic outline and summary of these deep learning models and technologies used for prostate cancer management. A literature search was carried out for English language articles over the last two decades from 2000–2021, and present in Scopus, MEDLINE, Clinicaltrials.gov, Science Direct, Web of Science and Google Scholar. A total of 224 articles were identified on the initial search. After screening, 64 articles were identified as related to applications in urology, from which 24 articles were identified to be solely related to the diagnosis and treatment of prostate cancer. The constant improvement in DL models should drive more research focusing on deep learning applications. The focus should be on improving models to the stage where they are ready to be implemented in clinical practice. Future research should prioritize developing models that can train on encrypted images, allowing increased data sharing and accessibility.",
      url:
        "https://www.mdpi.com/2077-0383/11/13/3575/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
      name: "ARLIF- IDS — Attention Augmented Real - Time Isolation Forest Intrusion Detection System",
      createdAt: "May 2022",
      description: "Accepted and Presented as a poster at the 43rd IEEE Symposium on Security and Privacy",
      url:
        "https://www.ieee-security.org/TC/SP2022/downloads/SP22-posters/sp22-posters-6.pdf",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
      name: "Stance Classification with Improved Elementary Classifiers Using Lemmatization(Grand Challenge) ",
      createdAt: "Oct 2020",
      description: "Published as result of securing the runners-up position in the IEEE BigMM Challenge",
      url:
        "https://doi.org/10.1109/BigMM50055.2020.00077",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "avatar.png",
    description:
      "I am active on all the handles listed below and usually reply within 24 hours",
  },
  blogSection: {

  },
  addressSection: {

  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
